module.exports = __webpack_public_path__ + "img/teacher10.84780ee6.jpeg";